const teamMembers = {
    executives: [
        {
            name: "Khathab Hamed",
            role: "Captain",
            image: "khathab.jpeg",
            email: "khamed@uwo.ca",
            linkedin: "https://www.linkedin.com/in/khathab-hamed/",
            website: "https://khathab.com",
            major: "Mechatronics and Computer Science w/ Co-op",
            firstYear: 2020,
            yearJoined: 2021,
        },
        {
            name: "Joshua Ray",
            role: "Mechanical Technical Director",
            image: "josh_ray.jpeg",
            email: "jray27@uwo.ca",
            linkedin: "https://www.linkedin.com/in/josh-ray-999557232/",
            major: "Mechatronics Engineering",
            firstYear: 2023,
            yearJoined: 2024

        },
        {
            name: "Joseph Toma",
            role: "Electrical Technical Director",
            image: "joseph_toma.jpeg",
            email: "jtoma5@uwo.ca",
            linkedin: "https://www.linkedin.com/in/josephtoma1/",
            major: "Mechatronics Engineering",
            firstYear: 2022,
            yearJoined: 2024
        },
        {
            name: "Harvey Yin",
            role: "Principal Wing Lead",
            image: "harvey_yin.jpeg",
            linkedin: "https://www.linkedin.com/in/harveyyin/",
            email: "yyin367@uwo.ca",
            major: "Mechanical Engineering",
            firstYear: 2023,
            yearJoined: 2023,
            level: "senior",
            project: "Advanced",
        },
        // {
        //     name: "NOT FILLED",
        //     role: "Recruitment Director",
        //     image: "empty.png"
        // },
    ],
    mechanicalTeam: [
        // Senior Leads
        {
            name: "Korsyn Pranger",
            role: "Senior Fuselage Lead",
            image: "korsyn_pranger.jpeg",
            linkedin: "https://www.linkedin.com/in/korsynpranger/",
            email: "kprange@uwo.ca",
            firstYear: 2024,
            yearJoined: 2022,
            level: "senior",
            project: "Regular",
        },
        {
            name: "Rayan Khawashki",
            role: "Senior Fuselage Lead",
            image: "rayan_khawashki.jpeg",
            linkedin: "https://www.linkedin.com/in/rayan-khawashki-160703334/",
            email: "rkhawash@uwo.ca",
            firstYear: 2024,
            yearJoined: 2024,
            level: "senior",
            project: "Advanced",
        },
        {
            name: "Filip Figiel",
            role: "Senior Wing Lead",
            image: "filip_figiel.jpeg",
            linkedin: "https://www.linkedin.com/in/filip-figiel-931a35315/",
            email: "ffigiel@uwo.ca",
            firstYear: 2021,
            yearJoined: 2024,
            level: "senior",
            project: "Regular",
        },
        {
            name: "Andres Monroy",
            role: "Senior Wing Lead",
            image: "andres_cantor_monroy.jpeg",
            linkedin: "https://www.linkedin.com/in/andrescantor23/",
            email: "acantorm@uwo.ca",
            firstYear: 2020,
            yearJoined: 2023,
            level: "senior",
            project: "Regular",
        },
        // {
        //     name: "NOT FILLED",
        //     role: "Senior Landing Systems Lead",
        //     image: "empty.png",
        //     level: "senior",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Senior Propulsion Lead",
        //     image: "empty.png",
        //     level: "senior",
        //     project: "Regular",
        // },
        // // Members
        // {
        //     name: "NOT FILLED",
        //     role: "Wing & Fuselage Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Tail Assembly Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Propulsion Assembly Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Wing Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Fuselage Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Tail Assembly Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Landing Systems Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Payload Systems Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Regular",
        // }
    ],
    
    electricalTeam: [
        // // Senior Leads
        // {
        //     name: "NOT FILLED",
        //     role: "Senior Avionics Lead",
        //     image: "empty.png",
        //     level: "senior",
        // },
        // // Members
        // {
        //     name: "NOT FILLED",
        //     role: "Power Systems Member",
        //     image: "empty.png",
        //     level: "member",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Avionics and Sensors Member",
        //     image: "empty.png",
        //     level: "member",
        // },
    ],
    
    softwareTeam: [
        // // Senior Leads
        // {
        //     name: "NOT FILLED",
        //     role: "Senior Flight Software Lead",
        //     image: "empty.png",
        //     level: "senior",
        //     project: "Advanded",
        // },
        // // Members
        // {
        //     name: "NOT FILLED",
        //     role: "Flight Software Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Advanded",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Simulation and Tooling Member",
        //     image: "empty.png",
        //     level: "member",
        //     project: "Advanded",
        // },
    ],


    operations: [
        // {
        //     name: "NOT FILLED",
        //     role: "Sponsorship Lead",
        //     image: "empty.png",
        //     level: "lead",
        // },
        // {
        //     name: "NOT FILLED",
        //     role: "Social Media Lead",
        //     image: "empty.png",
        //     level: "lead",
        // },
    ]
};

const notableAlumni = [
    {
        name: "John Langlois",
        role: "Controls Captain",
        roleYear: 2025,
        major: "Software Engineering",
        project: "Regular",
    },
    {
        name: "Matthew Soldo",
        role: "Mechanical Captain",
        roleYear: 2024,
        major: "Mechanical Engineering",
        project: "Regular",
    },
    {
        name: "Jeff St. Jean",
        role: "Controls Captain",
        roleYear: 2024,
        major: "Mechatronics Engineering & Computer Science Dual Degree w/ Co-op",
        project: "Regular",
    },
    {
        name: "Channey Kim",
        role: "Mechanical Captain",
        roleYear: 2023,
        major: "Mechanical Engineering and Ivey HBA",
        project: "Regular",
    },
    {
        name: "Mike Tryggvason",
        role: "Manager",
        roleYear: 2008,
        major: "Mechanical Engineering",
        project: "Regular",
    }
];

export { teamMembers, notableAlumni };

